import { z } from "zod";

import { DeviceTypeList } from "../../../schemas/analytics/base";
import { castToBool } from "../../../utils";

export const GetScreenshotRequestQueryParamSchema = z.object({
  path: z.string(),
  device: z.enum(DeviceTypeList),
  fresh: castToBool.optional(),
  hash: z.string(),
  thumbnail: castToBool.optional(),
  fullPage: castToBool.optional(),
  scroll: castToBool.optional(),
  experienceId: z.string().optional(),
  variationId: z.string().optional(),
  width: z.string().optional(),
  height: z.string().optional(),
});

export type GetScreenshotRequestQueryParamType = z.infer<
  typeof GetScreenshotRequestQueryParamSchema
>;

export const GetScreenshotResponseBodySchema = z.object({
  url: z.string(),
});

export type GetScreenshotResponseBodyType = z.infer<
  typeof GetScreenshotResponseBodySchema
>;
